module.exports = __webpack_public_path__ + "media/white-label/organization-info-t-53a89940.png";